module.exports = __webpack_public_path__ + "img/UsgsWhiteSymbol.949654e2.svg";